import { SHOW_TOAST, HIDE_TOAST } from '../toast/actionTypes';

const initState = {
  toast: {
    show: false,
    message: '',
    messagebold: '',
    type: 'success'
  }
};

/**
 * Reducer function for managing the state of the toast component.
 * @param {Object} state - The current state of the toast component.
 * @param {Object} action - The action object that contains the type and payload.
 * @returns The updated state of the toast component.
 */
const ToastReducer = (state = initState, action) => {
  if (action.type === SHOW_TOAST) {
    return {
      ...state,
      toast: { show: true, ...action.payload }
    };
  }
  if (action.type === HIDE_TOAST) {
    return {
      ...state,
      toast: {
        ...state.toast,
        show: false,
      }
    };
  }

  return state;
};

export default ToastReducer;
